export default __webpack_public_path__ + "static/media/app_preview_2.8319fa1c.svg";